import * as Sentry from '@sentry/react'

if (import.meta.env.VITE_ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: 'https://e4cc1b3f26a0107b252abc523d91ad27@o243844.ingest.us.sentry.io/4508994262335488',
  })
}
